<template>
  <div :class="tableClasses">
    <table class="simple-table__table">
      <thead v-if="thead && thead.length">
        <tr>
          <th
            v-for="(th, index) in thead"
            :key="index + th.name"
            :data-name="th.name"
            :style="thStyle(th)"
            class="simple-table__table__th"
          >
            {{ th.title }}
          </th>
        </tr>
      </thead>
      <tbody v-if="tbody && tbody.length">
        <tr
          v-for="(tr, index) in tbody"
          :key="index"
          :data-name="tr.name"
          :style="style(tr)"
          class="simple-table__table__tr"
        >
          <td
            v-for="(cell, j) in tr.cells"
            :key="j + index + cell.name"
            :style="style(cell)"
            class="simple-table__table__tr__td"
          >
            <slot name="cell" :data="cell" :id="tr.id !== undefined ? tr.id : ''">
              {{ cell.value }}
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "M4SimpleTable",
  data() {
    return {};
  },
  props: {
    thead: Array,
    tbody: Array,
    size: {
      type: String,
      default() {
        return "md";
      }
    }
  },
  computed: {
    tableClasses() {
      let classes = ["simple-table"];

      if (this.size) {
        classes.push("simple-table--size-" + this.size);
      }

      return classes;
    }
  },
  methods: {
    thStyle(th) {
      let style = th.style ? th.style : {};
      if (th.width) {
        style.width = th.width + "%";
      }
      return style;
    },
    style(item) {
      return item.style ? item.style : {};
    }
  }
};
</script>
